<template>
  <div class="mrgn-top">
       <v-flex class="space1"></v-flex>
           <sequential-entrance fromBottom delay="800" >
    <template v-for="(item, index) in items">
      <v-list-item two-line :key="index">
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle>Command : {{item.explanation}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
        </sequential-entrance>
  </div>
</template>

<script>
export default {
  name: "command assistant",
  components: {},
  data() {
    return {
      items: [
        {
          title: "Review your daily Responsibilities",
          explanation: "Start Briefing",
        },
        {
          title: "Ask price of your phone",
          explanation: "What's the cost of an iPhone 11",
        },
        {
          title: "Ask assistant to book a meeting room",
          explanation: "book a meeting room at 5pm",
        },
        {
          title: "Ask time",
          explanation: " what time is it?",
        },
        {
          title: "Navigate to Screen by Voice command",
          explanation: "Navigate to Dashboard",
        },
      ],
    };
  },
};
</script>

<style scoped>
.space {
  height: 100px;
}
.space1 {
  height: 30px;
}
.mrgn-top {
  text-align: center;
}
.center-aligned {
  text-align: center;
  color: rgb(58, 57, 57);
}
h3 {
  color: #888;
}
</style>
